import React from 'react';

import { Stack, Typography } from '@mui/material';

import { NO_STANDALONE_SCHEDULE_BRANDS } from '~/consts/brands';

import type { ImportBlocker } from '../Detail/OfferBuilder/DealInformation/tabs/campaignSchedules/types';

type Props = {
  blockers: Array<ImportBlocker>;
};

export default function ImportBlockersList({ blockers }: Props) {
  const regionCoverageBlockers = blockers.filter((blocker) => blocker.code === 'missing_region_coverage');
  const hasAgentHubRegionCoverageBlocker = regionCoverageBlockers.some((blocker) =>
    NO_STANDALONE_SCHEDULE_BRANDS.includes(blocker.brand),
  );
  const hasOtherRegionCoverageBlocker = regionCoverageBlockers.some(
    (blocker) => !NO_STANDALONE_SCHEDULE_BRANDS.includes(blocker.brand),
  );

  return (
    <>
      <Stack component="ul" spacing={1} sx={{ m: 0, pl: 2.5 }}>
        {blockers.map((blocker, index) => (
          <Typography
            component="li"
            key={`${blocker.code}-${blocker.brand}-${blocker.type ?? ''}-${blocker.region ?? index}`}
            sx={{ whiteSpace: 'pre-line' }}
            variant="body2"
          >
            {blocker.message}
          </Typography>
        ))}
      </Stack>
      {hasAgentHubRegionCoverageBlocker && (
        <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
          These schedules are generated automatically from Luxury Escapes&apos; own schedules — add the missing Luxury
          Escapes schedule types covering those regions in Salesforce, then re-import.
        </Typography>
      )}
      {hasOtherRegionCoverageBlocker && (
        <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
          Add the missing schedule types covering those regions in Salesforce, then re-import.
        </Typography>
      )}
      {blockers.some((blocker) => blocker.code === 'conflicting_source_records') && (
        <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
          Only one can be imported — reconcile these records in Salesforce, then re-import.
        </Typography>
      )}
    </>
  );
}
